import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [showVideoModal, setShowVideoModal] = useState(false);

  return (
    <>
      <section 
        id="inicio"
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/e4ec18111bb67828bbb9fb9ca2589e29.jpg')`
        }}
      >
        <div className="container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              Libros de Fieltro
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400">
                Mágicos
              </span>
            </h1>
            
            {/* Logo y nombre MANUK */}
            <div className="flex items-center justify-center gap-4 mb-8">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/8f780ed6b1c45f0786e7de84a9f8546e.jpeg" 
                  alt="MANUK Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-5xl md:text-6xl font-bold text-white uppercase" 
                   style={{ 
                     textShadow: '3px 3px 6px rgba(0, 0, 0, 0.7), 0 0 20px rgba(0, 0, 0, 0.5)'
                   }}>
                MANUK
              </div>
            </div>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
              Descubre nuestra colección única de libros infantiles de fieltro hechos a mano. 
              Cada página es una aventura sensorial que estimula la creatividad y el aprendizaje de los más pequeños.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <Button size="lg" className="text-lg px-10 py-4">
                <i className="ri-shopping-cart-line mr-2"></i>
                Ver Productos
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-gray-900"
                onClick={() => setShowVideoModal(true)}
              >
                <i className="ri-play-circle-line mr-2"></i>
                Ver Video
              </Button>
            </div>

            {/* Características destacadas */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hand-heart-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Hecho a Mano</h3>
                <p className="text-gray-200">Cada libro es único, creado con amor y atención al detalle</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Materiales Seguros</h3>
                <p className="text-gray-200">Utilizamos solo materiales no tóxicos y seguros para niños</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Educativo</h3>
                <p className="text-gray-200">Diseñados para estimular el aprendizaje y desarrollo infantil</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setShowVideoModal(false)}
        >
          <div 
            className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowVideoModal(false)}
              className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center text-gray-800 hover:text-gray-900 transition-all cursor-pointer shadow-lg"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <div className="aspect-[9/16] w-full">
              <iframe
                src="https://www.instagram.com/p/DPEa-XKEfJc/embed"
                className="w-full h-full"
                frameBorder="0"
                scrolling="no"
                allowTransparency={true}
                allow="encrypted-media"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
